import httpClient from 'utils/api.utils';
import config from 'utils/config';
import { getIsPeopleCuesOrg } from './userApi';

const orgApi = {
  getOrgAccessibleModules: () =>
    httpClient.get(
      `${config.blitzApiUrl}/v1/blitz/org/modules`,
      {},
      {},
      {},
      getIsPeopleCuesOrg()
    ),
  getAllSubscriptionsForOrg: () =>
    httpClient.get(
      `${config.peopleApiUrl}/subscription/get-all-org-subscriptions`
    ),
  getHrisIntegrationStatus: () =>
    httpClient.get(
      `${config.blitzApiUrl}/v1/blitz/hris/integration-details`,
      {},
      {},
      {},
      getIsPeopleCuesOrg()
    )
};

export default orgApi;
